/**
 * @generated SignedSource<<e594baf03984e9aa6203d78452608273>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleRoutineOccasionListItem_RoutineOccasion$data = {
  readonly completedTaskExecutionCount: number | null;
  readonly routine: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleRoutineListItemContent_Routine">;
  };
  readonly sequenceNumber: number;
  readonly totalTaskExecutionCount: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionStatusCircle_RoutineOccasion" | "TeamScheduleListItemScheduleRange_routineOccasion" | "TeamScheduleRoutineListItemContent_RoutineOccasion" | "TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion">;
  readonly " $fragmentType": "TeamScheduleRoutineOccasionListItem_RoutineOccasion";
};
export type TeamScheduleRoutineOccasionListItem_RoutineOccasion$key = {
  readonly " $data"?: TeamScheduleRoutineOccasionListItem_RoutineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleRoutineOccasionListItem_RoutineOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleRoutineOccasionListItem_RoutineOccasion",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineOccasionStatusCircle_RoutineOccasion"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamScheduleRoutineListItemContent_RoutineOccasion"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamScheduleListItemScheduleRange_routineOccasion"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sequenceNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completedTaskExecutionCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalTaskExecutionCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routine",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamScheduleRoutineListItemContent_Routine"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};

(node as any).hash = "e31d893a9c886ea6510ea604ff8518bc";

export default node;
